module.exports = __webpack_public_path__ + "static/media/analyticsIcon.e811cfe2.svg";